import React, { useState } from "react";
import SlimCTA from "components/SlimCTA";
import { BUTTON_CLASS_CONTEXT, UI_THEME } from "utils/constants/ui";
import { formFactorAction } from "utils/view";
import { useCtxReferences, useIsAuthed } from "utils/selectors";
import { HUB_APP_SUB_SECTION } from "utils/constants/navigation";

const RefreshOrReturnNotice = ({ actions, subheader } = { actions: [] }) => {
  const [loading, setLoading] = useState(false);
  const { application } = useCtxReferences();
  const isAuthed = useIsAuthed();
  const ctxSubheader = [
    `We couldn't load the data for this page. ${formFactorAction()} refresh to try again.`
  ];
  if (subheader) {
    ctxSubheader.push(subheader);
  }
  let ctxActions = [
    {
      rel: "noopener noreferrer",
      loading,
      onClick: () => {
        setLoading(true);

        const { href } = window.location;
        window.location.href = href;
      },
      theme: UI_THEME.SLIM,
      copy: "Refresh",
      tag: "a"
    }
  ];
  if (Array.isArray(actions)) {
    ctxActions = ctxActions.concat(actions);
  }
  if (isAuthed && application) {
    ctxSubheader.push("Or head back to your hub.");
    const destination = `${interpolateRoute(PATHS.HUB_APPLICATIONS_SHOW, {
      application
    })}/${HUB_APP_SUB_SECTION.HOME}`;
    ctxActions.unshift({
      href: destination,
      theme: UI_THEME.SLIM,
      classes: {
        contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
      },
      copy: "Hub",
      tag: "link"
    });
  }

  return (
    <div className="h-100 w-100">
      <main className="ph3 pb3 h-100">
        <div className="measure center">
          <div className="pv3 pt4-ns dib w-100 ph0-ns">
            <SlimCTA
              header="No data"
              subheader={ctxSubheader.join(" ")}
              customClasses={{
                container:
                  "w-100 flex flex-column justify-between ba br2 hairline-1 pa3 items-start bg-white",
                actionsWrapper: "pt2"
              }}
              actions={ctxActions}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default RefreshOrReturnNotice;
